import { makeStyles } from "tss-react/mui";
import { getRootUrl } from "@miplatform/utils";
import { MiPrintFooter } from "./MiPrintFooter";
import { MiPrintHeader } from "./MiPrintHeader";

export const MiPrintTemplateExtended = ({
  account,
  headerFields,
  highlightedHeaderField = null,
  statusHeaderField = null,
  showPrintedDate = false,
  hideWatermark = false,
  children,
}) => {
  const API_URL = getRootUrl();
  const {
    legalName,
    phoneNumber,
    facsimileNumber,
    website,
    email,
    address,
    watermark,
    logo,
    licenses,
    invoiceTermsAndConditionsHtml,
  } = account ?? {};
  const { classes } = useStyles();

  return (
    <div className={classes.printWrapper}>
      {!hideWatermark && watermark ? (
        <img
          className={classes.watermark}
          src={`${API_URL}/${watermark?.referenceId}`}
          alt="watermark"
        />
      ) : null}
      <table className={classes.table}>
        <thead>
          <tr>
            <td>
              <div className={classes.headerSpace}>&nbsp;</div>
            </td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <div className={classes.content}>{children}</div>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td>
              <div className={classes.footerSpace}>&nbsp;</div>
            </td>
          </tr>
        </tfoot>
      </table>
      <div className={classes.header}>
        <MiPrintHeader
          account={{
            legalName,
            phoneNumber,
            facsimileNumber,
            website,
            email,
            address,
            logo,
          }}
          headerFields={headerFields}
          highlightedHeaderField={highlightedHeaderField}
          statusHeaderField={statusHeaderField}
          showPrintedDate={showPrintedDate}
        />
      </div>
      <div className={classes.footer}>
        <MiPrintFooter
          invoiceTermsAndConditionsHtml={invoiceTermsAndConditionsHtml}
          licenses={licenses}
        />
      </div>
    </div>
  );
};

const useStyles = makeStyles()((theme) => ({
  "@global": {
    "@media print": {
      body: {
        margin: 0,
        padding: 0,
      },
    },
  },
  printWrapper: {
    display: "none",
    position: "relative",
    width: "8.5in",
    minHeight: "100vh",
    "@media print": {
      display: "block",
    },
  },
  watermark: {
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    pointerEvents: "none",
    width: "70%",
    height: "70%",
    padding: theme.spacing(6),
    objectFit: "contain",
    zIndex: 0,
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
  },
  header: {
    position: "fixed",
    top: 0,
    width: "100%",
    zIndex: 2,
    "@media print": {
      left: 0,
      width: "100%",
      padding: theme.spacing(6),
    },
  },
  headerSpace: {
    height: 108,
    "@media print": {
      height: 108,
      width: "100%",
      left: 0,
    },
  },
  footer: {
    position: "fixed",
    bottom: 0,
    width: "100%",
    zIndex: 2,
    padding: theme.spacing(3, 6),
    "@media print": {
      left: 0,
      width: "100%",
    },
  },
  footerSpace: {
    height: 88,
    "@media print": {
      height: 88,
      width: "100%",
      left: 0,
    },
  },
  content: {
    position: "relative",
    zIndex: 1,
    width: "100%",
    "@media print": {
      width: "100% !important",
      padding: theme.spacing(2, 6),
      boxSizing: "border-box",
    },
  },
}));
